export default __webpack_public_path__ + "static/media/ecuacion.7d35fcf5.png";